<template>
  <div class="title">
    <div class="text-topic">
      <i
        :class="[
          notification_code_icon[code]
        ]"
        class="text-warning"
      />
      <strong>
        {{ $t(`notification_code.${code}`) }}
        -
        {{ $t(`platform_code.${platform}`) }}
      </strong>
    </div>
    <div class="text-detail">
      <div>
        <span v-if="!['', 'unknown'].includes(tableNumber)">
          {{ $t('apps.pos.message.tablenumber', { ref_name: refName, number: tableNumber }) }}
        </span>
        <span v-if="!['', 'unknown'].includes(queueNumber)">
          {{ $t('apps.pos.message.queuenumber', { number: queueNumber }) }}
        </span>
      </div>
      <div v-if="orderDetail.length">
        <ul>
          <li
            v-for="(order, index) in orderDetail"
            :key="index"
            style="list-style: disc;margin-left: 15px;"
          >
            <div class="d-flex flex-column">
              <div>
                {{ order.item }}
              </div>
              <div
                v-for="(modiName, modiIndex) in order.modifiers"
                :key="modiIndex">
                + {{ modiName }}
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div class="text-helper">
      <span style="color: #ccc;">
        {{ getFriendlyTime(new Date(Number(dateTime)).toISOString()) }}
      </span>
      <span
        v-if="responseStatus === FIREBASE_NOTIFY_RESPONSE_STATUS.APPROVED"
        class="text-success">
        {{ $t('message.approved') }}
      </span>
      <span
        v-if="responseStatus === FIREBASE_NOTIFY_RESPONSE_STATUS.REJECTED"
        class="text-danger">
        {{ $t('message.rejected') }}
      </span>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { FIREBASE_NOTIFY_RESPONSE_STATUS } from '../../helpers/enum'
import { getMasterDataText } from '@/helpers'

export default {
  props: {
    code: String,
    platform: String,
    dateTime: Number,
    queueNumber: String,
    tableNumber: String,
    orderDetail: Array,
    responseStatus: String,
  },

  data() {
    return {
      FIREBASE_NOTIFY_RESPONSE_STATUS,
      FIREBASE_NOTIFY_RESPONSE_STATUS,
      notification_code_icon: {
        request_approve_access: 'fas fa-user-shield',
        request_approve_orders: 'fas fa-star',
        new_orders_created: 'fas fa-star',
        new_queue_created: null,
        call_staff: 'fas fa-hand-sparkles',
        call_checkout: 'fas fa-hand-sparkles',
      },
    }
  },

  computed: {
    ...mapGetters({
      posSettings: 'getPosSetting',
    }),
    refName () {
      return getMasterDataText(this.posSettings.table.ref_name, this.$t)
    },
  },
}
</script>

<style scoped>
.title {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.title .text-topic {
  font-size: 14px;
}

.title .text-detail {
  font-size: 14px;
}

.title .text-helper {
  font-weight: bold;
  font-size: 11px;
}
</style>



// WEBPACK FOOTER //
// src/components/base/BaseNotificationTitle.vue